import moment from 'moment';
import mediaQuery from './../../mixins/mediaQuery';

export default {
  data() {
    return {
      timeframeHeight: 0,
    };
  },

  props: {
    day: {
      required: true,
      type: Object,
    },

    displayWeekends: {
      required: true,
      type: Boolean,
    },

    list: {
      required: true,
      type: Array,
    },

    exceptions: {
      required: true,
      type: Array,
    },

    create: {
      required: false,
      type: Function,
    },

    edit: {
      required: false,
      type: Function,
    },

    startTime: {
      required: false,
      type: String,
      default: '00:00',
    },

    endTime: {
      required: false,
      type: String,
      default: '23:59',
    },
  },

  computed: {
    timeframes() {
      const frames = [];
      const framesLength = moment(this.endTime, 'HH:mm').diff(moment(this.startTime, 'HH:mm'), 'minutes');
      for (let i = 0; i < framesLength; i += 1) {
        const time = moment(this.startTime, 'HH:mm').add(i, 'minutes').format('HH:mm');
        if (time.split(':')[1] === '00') {
          frames.push(time);
        }
      }

      return frames;
    },
  },

  mounted() {
    this.timeframeHeight = this.$refs.timeframes.children[0].offsetHeight;
    const now = moment().format('HH:mm');
    document.querySelector('.main').scrollTop = this.offsetTop(now);
  },

  destroyed() {
    document.querySelector('.main').scrollTop = 0;
  },

  methods: {
    daysArray() {
      let c = 1;
      if (!this.isDesktop()) {
        return [0];
      }

      c = this.displayWeekends ? 7 : 5;
      return [...Array(c).keys()];
    },

    onEdit(date) {
      if (!this.edit) return false;

      return (o) => {
        this.edit(date, o);
      };
    },

    changeDay(day, method = 'add', quantity = 1) {
      return moment(day)[method](quantity, 'days');
    },

    exceptionsList(day) {
      return this.exceptions.filter(e => (
        moment(e.start).format('DD') === moment(day).format('DD') ||
        moment(e.end).format('DD') === moment(day).format('DD') ||
        (moment(e.start).isBefore(moment(day)) && moment(e.end).isAfter(moment(day)))
      )).map((e) => {
        let duration = 0;
        let start = moment(e.start, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm');
        let end = moment(e.end, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm');
        let time = moment(e.start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
        if (
          moment(e.start).format('DD') === moment(day).format('DD') &&
          moment(e.end).format('DD') === moment(day).format('DD')
        ) {
          duration = moment(e.end).diff(moment(e.start), 'minutes');
        } else if (moment(e.start).format('DD') === moment(day).format('DD')) {
          end = moment(day).endOf('day').format('DD/MM/YYYY HH:mm');
          duration = moment(day).endOf('day').diff(moment(e.start), 'minutes');
        } else if (moment(e.end).format('DD') === moment(day).format('DD')) {
          time = moment(day).startOf('day').format('HH:mm');
          start = moment(day).startOf('day').format('DD/MM/YYYY HH:mm');
          duration = moment(e.end).diff(moment(day).startOf('day'), 'minutes');
        } else {
          start = moment(day).startOf('day').format('DD/MM/YYYY HH:mm');
          time = moment(day).startOf('day').format('HH:mm');
          end = moment(day).endOf('day').format('DD/MM/YYYY HH:mm');
          duration = moment(day).endOf('day').diff(moment(day).startOf('day'), 'minutes');
        }
        return Object.assign({}, e, {
          start,
          end,
          time,
          duration,
          exception: true,
        });
      });
    },

    appointments(day) {
      if (!this.timeframeHeight) return [];

      const appointments = [];

      const list = this.list.filter(a => (
        moment(a.date).format('DD') === moment(day).format('DD') &&
        a.orderStatus !== 'cancelled'
      )).map(a => Object.assign({}, a, {
        end: moment(a.start, 'DD/MM/YYYY HH:mm').add(a.duration, 'minutes'),
      }));

      const finalList = [...list, ...this.exceptionsList(day)].sort((a, b) => (
        moment(a.start, 'DD/MM/YYYY HH:mm').diff(moment(b.start, 'DD/MM/YYYY HH:mm'))
      ));

      const isToday = moment(day).startOf('day').diff(moment().startOf('day'), 'days');
      finalList.forEach((a) => {
        const appointment = Object.assign({}, a, {
          offsetTop: this.offsetTop(a.time),
          height: this.height(a.time, a.duration),
        });
        appointments.push(appointment);
      });

      const freeSpots = [];
      if (isToday >= 0) {
        const start = isToday === 0 ? moment() : moment(day).startOf('day');
        const end = moment(day).endOf('day');
        freeSpots.push({
          slot: true,
          start: moment(start).format('DD/MM/YYYY HH:mm'),
          duration: end.diff(start, 'minutes'),
        });
      }
      const adjustFreeSpots = (spots) => {
        const newSpots = [];
        const everySpotIsOk = spots.every((spot) => {
          const conflictFree = appointments.every((a) => {
            if (
              moment(a.start, 'DD/MM/YYYY HH:mm').isAfter(moment(spot.start, 'DD/MM/YYYY HH:mm')) &&
              moment(a.start, 'DD/MM/YYYY HH:mm').isBefore(moment(spot.start, 'DD/MM/YYYY HH:mm').add(spot.duration, 'minutes')) &&
              moment(a.end, 'DD/MM/YYYY HH:mm').isAfter(moment(spot.start, 'DD/MM/YYYY HH:mm')) &&
              moment(a.end, 'DD/MM/YYYY HH:mm').isBefore(moment(spot.start, 'DD/MM/YYYY HH:mm').add(spot.duration, 'minutes'))
            ) {
              newSpots.push(Object.assign({}, spot, {
                duration: moment(a.start, 'DD/MM/YYYY HH:mm').diff(moment(spot.start, 'DD/MM/YYYY HH:mm'), 'minutes'),
              }));
              newSpots.push(Object.assign({}, spot, {
                start: a.end,
                duration: moment(spot.start, 'DD/MM/YYYY HH:mm').add(spot.duration, 'minutes')
                .diff(moment(a.end, 'DD/MM/YYYY HH:mm'), 'minutes'),
              }));
              return false;
            } else if (
              moment(a.start, 'DD/MM/YYYY HH:mm').isAfter(moment(spot.start, 'DD/MM/YYYY HH:mm')) &&
              moment(a.start, 'DD/MM/YYYY HH:mm').isBefore(moment(spot.start, 'DD/MM/YYYY HH:mm').add(spot.duration, 'minutes'))
            ) {
              newSpots.push(Object.assign({}, spot, {
                duration: moment(a.start, 'DD/MM/YYYY HH:mm').diff(moment(spot.start, 'DD/MM/YYYY HH:mm'), 'minutes'),
              }));
              return false;
            } else if (
              moment(a.end, 'DD/MM/YYYY HH:mm').isAfter(moment(spot.start, 'DD/MM/YYYY HH:mm')) &&
              moment(a.end, 'DD/MM/YYYY HH:mm').isBefore(moment(spot.start, 'DD/MM/YYYY HH:mm').add(spot.duration, 'minutes'))
            ) {
              newSpots.push(Object.assign({}, spot, {
                start: a.end,
                duration: moment(spot.start, 'DD/MM/YYYY HH:mm').add(spot.duration, 'minutes')
                .diff(moment(a.end, 'DD/MM/YYYY HH:mm'), 'minutes'),
              }));
              return false;
            } else if (
              moment(a.start, 'DD/MM/YYYY HH:mm').isSameOrBefore(moment(spot.start, 'DD/MM/YYYY HH:mm')) &&
              moment(a.end, 'DD/MM/YYYY HH:mm').isSameOrAfter(moment(spot.start, 'DD/MM/YYYY HH:mm').add(spot.duration, 'minutes'))
            ) {
              return false;
            }

            return true;
          });

          if (conflictFree) {
            newSpots.push(spot);
          }

          return conflictFree;
        });

        if (everySpotIsOk) {
          return newSpots;
        }

        return adjustFreeSpots(newSpots);
      };

      return [
        ...appointments,
        ...adjustFreeSpots(freeSpots).map(s => Object.assign({}, s, {
          offsetTop: this.offsetTop(moment(s.start, 'DD/MM/YYYY HH:mm').format('HH:mm')),
          height: this.height(moment(s.start, 'DD/MM/YYYY HH:mm').format('HH:mm'), s.duration),
        })),
      ];
    },

    offsetTop(time) {
      const H = this.timeframeHeight;
      const offset = ((Number(time.split(':')[0]) - Number(this.startTime.split(':')[0])) * H) + (time.split(':')[1] * (H / 60));

      return offset >= 0 ? offset : 0;
    },

    height(time, duration) {
      const H = this.timeframeHeight;
      const diff = moment(time, 'HH:mm').diff(moment(this.startTime, 'HH:mm'), 'minutes');
      if (diff < 0) {
        duration = Number(duration) + diff;
      }

      return (duration * (H / 60)) - 3;
    },
  },

  components: {
    VCalendarDay: require('./../calendarDay/calendarDay.vue'),
  },

  mixins: [
    mediaQuery,
  ],
};



// WEBPACK FOOTER //
// ./src/app/components/calendar/calendar.js